import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';

class ErrorNotFound extends React.Component {
  constructor(props) {
    super();
    this.state = {

    };

  }
  componentDidMount() {
    
  }
  render() {

    return (
      <div className="ErrorNotFound">
          <div className="container-fluid">
            <div className="row">
                <div className="col-md-12 d-flex justify-content-center
                align-items-center" style={{minHeight:'500px'}}>
                    <div className="text-center">
                        <h1>404 Not Found!</h1>
                        <h4>Sorry! That page doesn't seem to exist.</h4>
                    </div>
                </div>
            </div>
          </div>
      </div>
    );
  }
}

export default ErrorNotFound;

